// Shopify's spam protection hooks the form's native submit event to inject its
// captcha token as a hidden field. Intercepting with fetch() stripped that
// token, so every post failed the check and was served a fresh challenge page.
// The form therefore submits natively; Shopify returns to this same page with
// ?contact_posted=true anchored at the form, and the success/error states are
// rendered server-side from form.posted_successfully? and form.errors.
document.addEventListener('DOMContentLoaded', () => {
  const SUCCESS_AUTO_HIDE_MS = 6000;
  const POSTED_PARAM = 'contact_posted';

  const url = new URL(window.location.href);
  if (url.searchParams.get(POSTED_PARAM) !== 'true') return;

  for (const wrapper of document.querySelectorAll('[data-contact-form]')) {
    const success = wrapper.querySelector('[data-contact-success]');
    if (!success || success.hidden) continue;

    setTimeout(() => {
      success.hidden = true;
    }, SUCCESS_AUTO_HIDE_MS);
  }

  // Without this a refresh re-renders the thank-you for a submission that is
  // already finished. The hash is preserved, so the form stays scrolled into view.
  url.searchParams.delete(POSTED_PARAM);
  window.history.replaceState({}, '', url);
});
